import script from "./ReportsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsTable.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsTable.vue?vue&type=style&index=0&id=03a4eb62&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a4eb62"]])

export default __exports__